"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.inRange = function (value, values) {
  if (value >= values.min && value <= values.max) {
    return true;
  }

  return false;
};

exports.validationUtils = {
  inRange: exports.inRange
};

exports.prepareLeftRightPositions = function (props) {
  var positions = props.partPositions || [];
  var defaultPos = props.defaultPosition || 'none'; // console.log('TAAAAP', props);

  if (positions.length === 0) {
    for (var i = 0; i < props.qty; i++) {
      positions.push(defaultPos);
    }
  } else if (positions.length > 0) {
    if (props.prevQty < props.qty) {
      // added troughs to the configuration
      var diff = props.qty - props.prevQty;

      for (var i = 0; i < diff; i++) {
        positions.push(defaultPos);
      }
    } else {
      // removed troughs from the configuration
      positions.length = props.qty;
    }
  }

  return {
    values: positions,
    positions: positions && positions.length > 0 ? positions : null
  };
};

exports.prepareBooleanPositions = function (props) {
  var prevPositionsCount = (props.prevQty + 1) * 3 - 4;
  var positionsCount = (props.qty + 1) * 3 - 4;
  var positions = props.partPositions || [false];

  if (positions.length === 1) {
    for (var i = 1; i < positionsCount; i++) {
      positions.push(false);
    }
  } else if (positions.length > 1) {
    if (prevPositionsCount < positionsCount) {
      // added troughs to the configuration
      var diff = positionsCount - prevPositionsCount;

      for (var i = 1; i < diff; i++) {
        positions.push(false);
      }
    } else {
      // removed troughs from the configuration
      positions.length = positionsCount;
    }
  }

  return {
    values: positions,
    positions: positions && positions.length > 0 ? positions : null
  };
};

exports.prepareCutOutPositions = function (props) {
  var prevPositionsCount = (props.prevQty + 1) * 3 - 4;
  var positionsCount = (props.qty + 1) * 3 - 4;
  var positions = props.partPositions || [false];

  if (positions.length === 1) {
    for (var i = 1; i < positionsCount; i++) {
      positions.push(false);
    }
  } else if (positions.length > 1) {
    if (prevPositionsCount < positionsCount) {
      // added troughs to the configuration
      var diff = positionsCount - prevPositionsCount;

      for (var i = 1; i < diff; i++) {
        positions.push(false);
      }
    } else {
      // removed troughs from the configuration
      positions.length = positionsCount;
    }
  }

  return {
    values: positions,
    positions: positions && positions.length > 0 ? positions : null
  };
};

exports.getMaxFromArrayOfNumbers = function (values) {
  return Math.max.apply(Math, values);
};

exports.getMinFromArrayOfNumbers = function (values) {
  return Math.min.apply(Math, values);
};